<template>
  <v-parallax :src="(expert.picture || {}).normal" :height="250">
    <div class="profile-details">
      <v-card>
        <img :src="expert.picture.thumb" height="150" width="150">
      </v-card>
      <h1 class="headline">{{ expert.nickname }}</h1>
      <a class="btn btn--block btn--flat btn--light" target="_blank" :href="expertUrl">{{ $t('expert.header.profile') }}</a>
    </div>
    <div v-if="withActions && $can('manage', 'team')" class="actions">
      <v-menu bottom left origin="top right">
        <v-btn slot="activator" primary light>
          {{ $t('expert.header.more') }}
          <v-icon light>arrow_drop_down</v-icon>
        </v-btn>
        <v-list>
          <v-list-item>
            <v-list-tile @click.native.stop="connect({ adminId: expert.id })">
              <v-list-tile-title>
                <v-icon>sync</v-icon>
                {{ $t('expert.header.connect') }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list-item>
          <v-list-item>
            <v-list-tile @click.native.stop="remove()">
              <v-list-tile-title>
                <v-icon>delete</v-icon>
                {{ $t('expert.header.delete') }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-parallax>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import expert from '@/mixins/expert'
  export default {
    mixins: [expert],
    props: {
      withActions: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters({
        platform: 'skiliko/session/currentPlatform'
      }),
      expertUrl () {
        return this.platform.multi_experts ? [
          this.platform.url,
          this.expert.id,
          (this.expert.nickname || '')
            .replace(/ /g, '-')
            .toLowerCase()
        ].join('/') : this.platform.url
      }
    },
    methods: {
      ...mapActions({
        removeExpert: 'skiliko/experts/remove',
        connect: 'skiliko/session/connectAs'
      }),
      remove () {
        if (confirm(this.$t('expert.header.confirmation'))) {
          this.removeExpert({ id: this.expert.id })
            .then(_ => this.$router.replace({ path: '/' }))
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .profile-details {
    position: absolute;
    bottom: 1em;
    left: 1em;

    h1 {
      position: absolute;
      left: 160px;
      bottom: -.5em;
      width: 100%;
      text-shadow: 0 0 1px white;
    }

    .card {
      width: 150px;
      height: 150px;
      padding: .3em;
      float: left;
    }

    .btn {
      position: absolute;
      bottom: 0;
      left: 0;
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .actions {
    position: absolute;
    bottom: 20px;
    right: 20px;
    margin: 0;

    a {
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/expert/Header.vue